import { useEffect, useState } from "react";
import { get, post } from "util/requests";
import styles from "./site_groups.module.css";
import { Dialog, Checkbox, TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

const SiteInterface = (props) => {
  const { sites = [], disabled = false, active_site_ids = [], setActiveSiteIds } = props;

  return (
    <div>
      <div className={styles.title_left}>Sites</div>
      <div className={styles.site_scroller}>
        {sites?.map((s) => (
          <div>
            <Checkbox
              disabled={disabled}
              key={s.code}
              checked={active_site_ids.includes(s.id)}
              className={styles.checkbox}
              onChange={(e) => {
                let _active_site_ids = [...active_site_ids];
                if (e.target.checked) {
                  _active_site_ids.push(s.id);
                } else {
                  _active_site_ids = _active_site_ids.filter((id) => id !== s.id);
                }
                setActiveSiteIds(_active_site_ids);
              }}
            />
            {`${s.name} (${s.code})`}
          </div>
        ))}
      </div>
    </div>
  );
};

const SiteModal = (props) => {
  const { open, close, data, selected_group_id, active_site_ids = [], fetchData } = props;
  const [localData, setLocalData] = useState({});

  useEffect(() => {
    if (open === "edit") {
      let _group = data?.groups?.find((s) => s.id === selected_group_id) || {};
      setLocalData({ ..._group, active_site_ids: [...active_site_ids] });
    } else {
      setLocalData({});
    }
  }, [open]);

  const setActiveSiteIds = (active_site_ids) => {
    setLocalData({ ...localData, active_site_ids: [...active_site_ids] });
  };

  return (
    <Dialog open={open} onClose={close}>
      <div className={styles.modal_wrapper}>
        <div className={styles.modal_title}>{`${open === "edit" ? "Edit" : "Add"} Site Group`}</div>
        <div className={styles.modal_body}>
          <div className={styles.text_entry}>
            <div className={styles.textfield_wrapper}>
              <TextField
                placeholder="Site Group Name"
                value={localData.name || ""}
                onChange={(e) => setLocalData({ ...localData, name: e.target.value })}
                autoComplete="off"
                sx={{
                  "& .MuiInputBase-input": {
                    padding: "0px",
                    paddingLeft: "10px",
                    textAlign: "left",
                  },
                }}
                fullWidth
                multiline
              />
            </div>
          </div>
          <SiteInterface
            sites={data?.sites}
            active_site_ids={localData.active_site_ids}
            setActiveSiteIds={setActiveSiteIds}
          />
        </div>
        <div className={styles.modal_button_wrapper}>
          {open === "edit" ? (
            <LoadingButton
              variant="contained"
              loading={false}
              onClick={() => {
                post(`/site_group/${selected_group_id}`, localData).then(() => {
                  close();
                  fetchData();
                });
              }}
              disabled={!localData.name || !localData.active_site_ids?.length}
            >
              Update
            </LoadingButton>
          ) : (
            <LoadingButton
              variant="contained"
              loading={false}
              onClick={() => {
                post("/site_group", localData).then(() => {
                  close();
                  fetchData();
                });
              }}
              disabled={!localData.name || !localData.active_site_ids?.length}
            >
              Add
            </LoadingButton>
          )}
          <LoadingButton disabled={false} variant="outlined" loading={false} onClick={close}>
            Cancel
          </LoadingButton>
        </div>
      </div>
    </Dialog>
  );
};

export default function SiteGroups(props) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  const close = () => {
    setOpen(false);
  };

  const fetchData = () => {
    get("/site_groups").then((ret) => {
      setData({ ...ret.data, selected_group_id: data?.selected_group_id || undefined });
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const active_site_ids =
    data?.selected_group_id &&
    data?.maps.filter((m) => m.site_group_id === data?.selected_group_id).map((m) => m.site_id);

  return (
    <div className={styles.flex}>
      <div>
        <div className={styles.title}>Site Group</div>
        {data?.groups?.map((g) => (
          <div
            className={data.selected_group_id === g.id ? styles.active_group_row : styles.group_row}
            onClick={() => setData({ ...data, selected_group_id: g.id })}
          >
            <div>{g.name}</div>
            {data.selected_group_id === g.id ? (
              <LoadingButton
                variant="outlined"
                sx={{
                  fontSize: 14,
                  padding: "0px",
                  paddingLeft: "8px",
                  paddingRight: "8px",
                }}
                loading={false}
                onClick={() => {
                  setOpen("edit");
                }}
              >
                Edit
              </LoadingButton>
            ) : null}
          </div>
        ))}
        <LoadingButton
          variant="outlined"
          loading={false}
          onClick={() => {
            setOpen(true);
          }}
          sx={{
            fontSize: 14,
            padding: "2px",
            paddingLeft: "10px",
            paddingRight: "10px",
          }}
        >
          Add Site Group
        </LoadingButton>
      </div>
      <SiteInterface sites={data?.sites} disabled active_site_ids={active_site_ids} />
      <SiteModal
        data={data}
        open={open}
        close={close}
        fetchData={fetchData}
        selected_group_id={data?.selected_group_id}
        active_site_ids={active_site_ids}
      />
    </div>
  );
}
